import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tag, Toast, Loading, Empty } from 'react-vant'
import teacherAffairsApi from '../../../api/teacherAffairs'

/**
 * 我的代课（教师端）
 *
 * 显示：被安排代课了哪些节（日期 / 班级 / 科目 / 节次）、本月代课节数、累计代课费。
 * Q8：本系统只负责统计与结算表，实际发放由财务系统处理。
 */
const RESOLUTION_MAP = {
  pending: { label: '待处理', color: '#94a3b8' },
  substitute: { label: '代课', color: '#056b4f' },
  swap: { label: '调课', color: '#0891b2' },
  move: { label: '移课', color: '#06b6d4' },
  merge: { label: '合班', color: '#7c3aed' },
  exempt: { label: '免处理', color: '#fa8c16' },
  no_impact: { label: '无需倒课', color: '#94a3b8' },
}

const FEE_STATUS_MAP = {
  pending: { label: '待结算', color: '#d97706' },
  confirmed: { label: '已确认', color: '#00b578' },
  settled: { label: '已结算', color: '#059669' },
}

const WEEKDAY = ['日', '一', '二', '三', '四', '五', '六']

const SubstitutePage = () => {
  const navigate = useNavigate()
  const [items, setItems] = useState([])
  const [totalLessons, setTotalLessons] = useState(0)
  const [totalFee, setTotalFee] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => { fetchData() }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await teacherAffairsApi.getMySubstitute()
      const data = res?.data || res || {}
      setItems(data.items || [])
      setTotalLessons(data.total_lessons || 0)
      setTotalFee(data.total_fee || 0)
    } catch (e) {
      Toast.fail('加载代课信息失败')
    } finally { setLoading(false) }
  }

  const cardStyle = {
    background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
    padding: '0 16px 28px', borderRadius: '0 0 24px 24px', color: '#fff',
  }
  const statBox = {
    flex: 1, background: 'rgba(255,255,255,0.2)', borderRadius: 14, padding: '14px 16px',
  }
  const statLbl = { fontSize: 12, color: 'rgba(255,255,255,0.85)' }
  const statNum = { fontSize: 26, fontWeight: 700, color: '#fff', marginTop: 4 }

  return (
    <div style={{ background: '#f5f8f6', minHeight: '100vh', paddingBottom: 80 }}>
      <div style={{
        background: '#056b4f', padding: '12px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div onClick={() => navigate(-1)} style={{ cursor: 'pointer', padding: 4 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <span style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>我的代课</span>
        <div style={{ width: 24 }} />
      </div>

      <div style={cardStyle}>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={statBox}>
            <div style={statLbl}>代课节数</div>
            <div style={statNum}>{totalLessons}<span style={{ fontSize: 13, fontWeight: 400 }}> 节</span></div>
          </div>
          <div style={statBox}>
            <div style={statLbl}>累计代课费</div>
            <div style={statNum}>{Number(totalFee || 0).toFixed(2)}<span style={{ fontSize: 13, fontWeight: 400 }}> 元</span></div>
          </div>
        </div>
      </div>

      <div style={{ padding: '16px 12px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}><Loading size={24} /></div>
        ) : items.length === 0 ? (
          <Empty description="暂无代课安排" />
        ) : (
          items.map(item => {
            const d = item.impact_date ? new Date(item.impact_date) : null
            const weekday = d ? `周${WEEKDAY[d.getDay()]}` : ''
            const feeMeta = FEE_STATUS_MAP[item.fee_status] || FEE_STATUS_MAP.pending
            return (
              <div key={item.id} style={{
                background: '#fff', borderRadius: 12, padding: 14, marginBottom: 10,
                boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
                borderLeft: '3px solid #056b4f',
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ fontSize: 15, fontWeight: 600 }}>
                    {item.impact_date || '待定'} {weekday}
                  </span>
                  <Tag color={feeMeta.color} plain style={{ margin: 0 }}>{feeMeta.label}</Tag>
                </div>
                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>
                  第 {item.period_index} 节 · {item.class_name || '未知班级'} · {item.subject_name || '未知科目'}
                </div>
                <div style={{ fontSize: 13, color: '#64748b' }}>
                  替 {item.leave_teacher_name || '同事'} 代课 {item.lesson_count} 节
                </div>
                <div style={{
                  marginTop: 8, paddingTop: 8, borderTop: '1px solid #f1f5f9',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}>
                  <span style={{ fontSize: 12, color: '#94a3b8' }}>
                    单节 ¥{Number(item.fee_rate || 0).toFixed(2)} × {item.lesson_count} 节
                  </span>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#ff5e1e' }}>
                    ¥{Number(item.fee_amount || 0).toFixed(2)}
                  </span>
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default SubstitutePage
